import React, { memo, ReactNode } from 'react';
import { areEqual } from 'Utils/equalityChecks';
import classes from './reportCard.module.css';

interface Props {
  title: string;
  subtitle?: string;
  loading: boolean;
  error: string | null;
  configKey: string;
  children: ReactNode;
}

function ReportCard({ title, subtitle, loading, error, children }: Props) {
  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <div>
          <h5 className={classes.title}>{title}</h5>
          {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
        </div>
      </div>
      <div className={classes.body}>
        {loading && (
          <div className={classes.loadingState}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        {error && !loading && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {!loading && !error && children}
      </div>
    </div>
  );
}

const ReportCardMemo = memo(ReportCard, areEqual);
export { ReportCardMemo as ReportCard };
